import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { MapPin, Plus, Trash2 } from "lucide-react";

export default function Villages() {
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const [adding, setAdding] = useState(false);

  const load = () => api.get("/villages").then(({ data }) => setList(data));

  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    setAdding(true);
    try {
      await api.post("/villages", { name: name.trim() });
      toast.success("Village added");
      setName("");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally { setAdding(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("Remove village?")) return;
    try {
      await api.delete(`/villages/${id}`);
      toast.success("Removed");
      load();
    } catch (e) {
      toast.error("Failed");
    }
  };

  return (
    <div className="p-6 lg:p-8" data-testid="villages-page">
      <div className="mb-6">
        <h1 className="font-heading font-bold text-3xl">Villages</h1>
        <p className="text-gray-600 text-sm">Pithapuram Mandal · {list.length} villages mapped</p>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-[0_2px_10px_rgba(0,0,0,0.04)] max-w-2xl mb-6">
        <h3 className="font-heading font-semibold mb-3">Add new village</h3>
        <div className="flex gap-3">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Village name" data-testid="village-name-input" onKeyDown={(e) => e.key === "Enter" && add()} />
          <Button onClick={add} disabled={adding} className="bg-[#1E3A8A] hover:bg-[#1E3A8A]/90" data-testid="add-village-btn">
            <Plus className="w-4 h-4 mr-1" /> Add
          </Button>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {list.map((v) => (
          <div key={v.village_id} className="group bg-white rounded-xl border border-gray-100 p-4 flex items-center justify-between hover:shadow-md transition-all" data-testid={`village-${v.name}`}>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-[#FEF3C7] text-[#92400E] flex items-center justify-center">
                <MapPin className="w-4 h-4" />
              </div>
              <div>
                <div className="font-medium">{v.name}</div>
                <div className="text-xs text-gray-500">{v.mandal}</div>
              </div>
            </div>
            <button onClick={() => remove(v.village_id)} className="opacity-0 group-hover:opacity-100 transition-opacity text-[#E11D48]" data-testid={`delete-${v.name}`}>
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
